import { Component, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Dictionary } from "src/app/store/models/common_types";
import { ReportingGridWrapperComponent } from "../reporting-grid-wrapper/reporting-grid-wrapper.component";
import { Store } from "@ngrx/store";
import { AppState, stateGetter } from "src/app/store/state/app.state";
import * as GlobalSubheaderActions from "../../store/actions/global-subheader.actions";
import { Subscription } from "rxjs";
import { ReportingPagesService } from "../reporting-pages.service";
import { ReportingPagesDataService } from "../reporting-pages-data.service";

@Component({
  selector: "app-reporting-industry",
  templateUrl: "./reporting-industry.component.html",
  styleUrls: ["./reporting-industry.component.scss"],
  host: { class: "industry-page-component" },
})
export class ReportingIndustryComponent implements OnInit {
  showSearch = true;
  showGridFilters: boolean;
  page: string;
  columns: {
    columnFields: Array<Dictionary<any>>;
    columnsData: Array<Dictionary<any>>;
    widthConfig: Array<string>;
  };
  gridUrl: string;
  sortKey: string;
  exportKey: string;
  exportColumns: Array<any>;
  globalSearchVal: string;
  coveragestatusList: Array<any> = [];
  @ViewChild(ReportingGridWrapperComponent)
  gridWrapperComp: ReportingGridWrapperComponent;
  storeSub: Subscription;
  isSellside: boolean;
  isDataSet: boolean;
  constructor(
    private route: ActivatedRoute,
    private store: Store<AppState>,
    private service: ReportingPagesService,
    private dataService: ReportingPagesDataService,
  ) {
    this.columns = {
      columnFields: [],
      columnsData: [],
      widthConfig: [],
    };
    this.isDataSet = false;
    this.coveragestatusList = this.dataService.getCoverageStatusValue();
  }

  ngOnInit() {
    this.globalSearchVal = "";
    this.exportKey = `INDUSTRY_PAGE_${this.route.snapshot.params.industryName}`;
    this.service.logUserOnRedirection("INDUSTRY_PAGE", {
      VALUE: this.route.snapshot.params.industryName,
    });

    this.route.params.subscribe(() => {
      this.page = "industry";
      const industryName = encodeURIComponent(
        this.route.snapshot.params.industryName,
      );
      this.gridUrl = `api/sectorindustrydata/?industry=${industryName}&`;
      const columnFields = [
        {
          field: "ticker",
          renderer: "link",
        },
        {
          field: "companyname",
          renderer: "link",
        },
        {
          field: "coveragestatus",
          renderer: null,
        },
        {
          field: "coveredsource",
          renderer: null,
        },
      ];
      const columnsData = [
        [
          {
            children: 1,
            header: "Ticker",
            sortKey: "ticker",
            showSort: true,
            showFilter: true,
            filterType: "text",
          },
          {
            children: 1,
            header: "Company",
            sortKey: "companyname",
            showSort: true,
            showFilter: true,
            filterType: "text",
          },
          {
            children: 1,
            header: "Coverage Status",
            sortKey: "coveragestatus",
            showSort: true,
            showFilter: true,
            filterType: "select",
            filterSelectValues: this.coveragestatusList,
            currentValue: "",
          },
          {
            children: 1,
            header: "Sources",
            sortKey: "coveredsource",
            showSort: true,
            showFilter: true,
            filterType: "text",
          },
        ],
      ];
      this.sortKey = "coveredsource";
      this.columns.columnFields = columnFields;
      this.columns.columnsData = columnsData;
      this.columns.widthConfig = ["auto", "25%", "20%", "20%"];
      this.exportColumns = columnFields.map((d) => {
        return d.field;
      });
      this.store.dispatch(new GlobalSubheaderActions.SubheaderChanged());
      this.storeSub = this.store
        .select(stateGetter("globalHeader", "globalSettings"))
        .subscribe((data: any) => {
          if (Object.keys(data).length === 0 && data.constructor === Object) {
            return;
          }
          this.isSellside = data.isSellside;
          if (this.isSellside) {
            this.columns.columnFields.push({
              field: "views",
              renderer: "report-view-link",
            });
            this.columns.columnsData[0].push({
              children: 1,
              header: "Views",
              sortKey: "views",
              showSort: false,
              showFilter: false,
            });
            this.columns.widthConfig.push("20%");
          }
          this.isDataSet = true;
        });
    });
  }

  toggleFilter(ev) {
    this.showGridFilters = ev.showFilters;
  }

  onSearch(val) {
    this.globalSearchVal = val;
  }

  onReloadGrid() {
    this.gridWrapperComp.gridReload();
  }
  ngOnDestroy() {
    this.storeSub.unsubscribe();
  }
}
